import {Component, EventEmitter, Output} from '@angular/core';
import {ColumnFilter, DataTableColumnData, DataTableConfig, DataTablePaginatedDataSource, TableAction} from '@cas-hub/acabim-common-client';
import {OrganisationUser} from '../../../_models/organisation/organisation-users.model';
import {OrganisationUsersService} from '../../../_services/organisation/organisation-users.service';

@Component({
    selector: 'acabim-admin-organisation-users',
    templateUrl: './organisation-users.component.html',
    styleUrls: ['./organisation-users.component.scss']
})
export class OrganisationUsersComponent extends DataTablePaginatedDataSource<OrganisationUser> {

    @Output() public userDetailsChanged = new EventEmitter();

    public readonly actions: TableAction[] = [];

    public readonly columnData: DataTableColumnData[] = [
        {displayName: 'First Name', objectPropertyName: 'user.firstName', colWidth: '12rem'},
        {displayName: 'Last Name', objectPropertyName: 'user.lastName'},
        {displayName: 'Email', objectPropertyName: 'user.email', colWidth: '20rem'},
        {displayName: 'Authentication Role', objectPropertyName: 'role', colWidth: '10rem', textAlign: 'center'},
        {displayName: 'Sub. remaining days', objectPropertyName: 'userSeat.remainingDays', colWidth: '10rem', textAlign: 'flex-end'},
        {displayName: 'Solution', objectPropertyName: 'solution'}
    ];

    public readonly columnFilters: ColumnFilter[] = [];

    public readonly config: DataTableConfig = {
        globalFilterFields: [],
        hasActions: false,
        hasCheckbox: false,
        hasDetailsButton: true,
        hasFilters: false,
        isExportEnabled: false,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        isSearchEnabled: false,
        searchPlaceHolder: '',
        tableHeading: '',
        emptyMessage: 'No users found'
    };

    constructor(organisationUsersService: OrganisationUsersService) {
        super((pagination, _) => organisationUsersService.getUsers(pagination));
    }

    public onAction(action: TableAction): void {
    }

    public onDataExpanded(value: OrganisationUser): void {
    }

    public onUserDetailsChanged(): void {
        this.showDetails = false;
        this.userDetailsChanged.emit();
        this.onRequestToRefreshData();
    }

    changeModalStatus(value: any): void {
        this.showDetails = value;
        this.userDetailsChanged.emit();
        this.onRequestToRefreshData();
    }
}
